<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="warning">
      <h4 class="alert-heading">
        {{ getContentItem("claimDetailNotFound") }}
      </h4>
      <p
        class="my-4"
      >
        {{ format(getContentItem("claimNotFoundExplanation"), claimNumber, tenantDetails.SupportPhoneNumber) }}
      </p>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { stringHelper } from "@/components/mixins/stringHelper";

  export default {
    name: "ClaimNotFound",
    mixins: [stringHelper],
    props: {
      claimNumber:  { type: String,  default: "" }
    },
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"])
    }
  };
</script>